import consts from '../consts/const';
import { saveBlock } from '../utils/blockNotice';
export const ADD_TO_COMMENTS = 'ADD_TO_COMMENTS';
export const DELETE_COMMENT = 'DELETE_COMMENT';
export const ADD_TO_COMUPDS = 'ADD_TO_COMUPDS';
export const ADD_TO_POSTS = 'ADD_TO_POSTS';
export const ADD_TO_UPDS = 'ADD_TO_UPDS';
export const ADD_VIEWS = 'ADD_VIEWS';
export const REMOVE_FOLLOW = 'REMOVE_FOLLOW';
export const ADD_TO_FOLLOW = 'ADD_TO_FOLLOW';
export const SET_FOLLOW = 'SET_FOLLOW';
export const ADD_TO_CHAT = 'ADD_TO_CHAT';
export const MARK_CHAT_DELIVERED = 'MARK_CHAT_DELIVERED';
export const DELETE_NOF = 'DELETE_NOF';
export const DELETE_MASS = 'DELETE_MASS';
export const DELETE_HISTORY = 'DELETE_HISTORY';
export const DELETE_POST = 'DELETE_POST';
export const UPDATE_POST = 'UPDATE_POST';
export const REORDER_USER_POSTS = 'REORDER_USER_POSTS';
export const CHANGELANG = 'CHANGELANG';
export const MAKE_SUB = 'MAKE_SUB';
export const MAKE_PAYMENT = 'MAKE_PAYMENT';

export const changelang = (lang) => {
  return {
    type: CHANGELANG,
    lang
  }
}
export const add_to_comments = (content,userid,postid,img,email,pid,parentId,media) => {
  return async dispatch =>{
    const res = await fetch(`/api/comments/`,{
       method:'POST',
       headers:{'content-Type':'application/json'},
       body:JSON.stringify({content: content || '',userid,postid,pid,parent_id: parentId || null, media: media || ''})
     });

     const ress = await res.json();
     if (!ress?.id) return;
  dispatch({type:ADD_TO_COMMENTS,id:ress.id,content:content,userid:userid,postid:postid,img:img,email:email,parentId: parentId || null, media: media || ress.media || ''})
}}

export const delete_comment = (id,userid,pid) => {
  return async dispatch =>{
    if (!id || !userid) return;
    const path = pid
      ? `/api/comments/${encodeURIComponent(id)}/${encodeURIComponent(userid)}/${encodeURIComponent(pid)}`
      : `/api/comments/${encodeURIComponent(id)}/${encodeURIComponent(userid)}`
    const res = await fetch(path, { method: 'DELETE' })
    if (!res.ok) return;
    dispatch({type:DELETE_COMMENT, id})
  }
}
export const add_to_posts = (userid,image,type,title,tages,discption,thumbnail,pid) => {
  return async (dispatch,getState) =>{
    const userid = getState().authReduse.id;
    const pid = getState().authReduse.pid;

    const res = await fetch(`/api/posts/`,{
       method:'POST',
       headers:{'content-Type':'application/json'},
       body:JSON.stringify({userid,image,type,title,tages,discption,thumbnail,pid})
     });

     const ress = await res.json();
     if (ress.msg === 'blocked') {
       saveBlock(ress)
       throw new Error(ress.text || 'You are blocked')
     }
     if (!res.ok) throw new Error(ress.text || ress.msg || 'Could not post')
  dispatch({type:ADD_TO_POSTS,postData:{id:ress.id,image:image,userid:userid,title:title,type:type,tages:tages,description:discption,thumbnail:thumbnail}})
}}
const persistVote = (userId, postId, type, isOn) => {
  try {
    const votes = JSON.parse(localStorage.getItem('pinweelo-votes') || '{}')
    const key = `${userId}:${postId}:${type}`
    if (isOn) votes[key] = true
    else delete votes[key]
    localStorage.setItem('pinweelo-votes', JSON.stringify(votes))
  } catch (err) {}
}

const sendVote = (actorId, postid, type, pid) => fetch(`/api/vud/updown`, {
  method: 'POST',
  headers: { 'content-Type': 'application/json' },
  body: JSON.stringify({ userid: actorId, postid, type, pid })
})

export const add_to_upds = (type, userid, postid) => {
  return async (dispatch, getState) => {
    const useridd = getState().authReduse.id
    const pid = getState().authReduse.pid
    const actorId = useridd || userid
    if (!actorId || !postid || !pid) return

    const mine = entry =>
      String(entry.userid) === String(actorId) && String(entry.postid) === String(postid)
    const savedOn = voteType => {
      try {
        const votes = JSON.parse(localStorage.getItem('pinweelo-votes') || '{}')
        return Boolean(votes[`${actorId}:${postid}:${voteType}`])
      } catch (err) {
        return false
      }
    }
    const inStore = voteType =>
      (getState().UpdsReduse.upds || []).some(entry => mine(entry) && entry.type === voteType)
    ;['p', 'd'].forEach(voteType => {
      if (savedOn(voteType) && !inStore(voteType)) {
        dispatch({ type: ADD_TO_UPDS, typee: voteType, userid: actorId, postid, skipDelta: true })
      }
    })

    const upds = getState().UpdsReduse.upds || []
    const hasType = voteType => upds.some(entry => mine(entry) && entry.type === voteType)
    const turningOn = !hasType(type)
    const other = type === 'p' ? 'd' : 'p'
    const dropOther = turningOn && hasType(other)

    dispatch({ type: ADD_TO_UPDS, typee: type, userid: actorId, postid })
    if (dropOther) dispatch({ type: ADD_TO_UPDS, typee: other, userid: actorId, postid })
    persistVote(actorId, postid, type, turningOn)
    if (dropOther) persistVote(actorId, postid, other, false)

    try {
      const res = await sendVote(actorId, postid, type, pid)
      if (!res.ok) throw new Error('vote failed')
      if (dropOther) {
        const otherRes = await sendVote(actorId, postid, other, pid)
        if (!otherRes.ok) throw new Error('vote failed')
      }
    } catch (err) {
      dispatch({ type: ADD_TO_UPDS, typee: type, userid: actorId, postid })
      if (dropOther) dispatch({ type: ADD_TO_UPDS, typee: other, userid: actorId, postid })
      persistVote(actorId, postid, type, !turningOn)
      if (dropOther) persistVote(actorId, postid, other, true)
    }
  }
}


export const add_to_comupds = (type,userid,commentId) => {
 return async (dispatch,getState) =>{
     const actorId = getState().authReduse.id || userid;
     const pid = getState().authReduse.pid
     if (!actorId || !commentId) return;
     const comment = (getState().CommentsReduse.Comments || []).find(item => String(item.id) === String(commentId))
     const was = comment && comment.userVote
     dispatch({type:ADD_TO_COMUPDS,typee:type,userid:actorId,commentId})
   try {
     const res = await fetch(`/api/vud/updowncom`,{
        method:'POST',
        headers:{'content-Type':'application/json'},
        body:JSON.stringify({userid: actorId,commentId,type,pid})
      })
     if (!res.ok) throw new Error('vote failed')
   } catch (err) {
     dispatch({type:ADD_TO_COMUPDS,typee:type,userid:actorId,commentId})
     if (was && was !== type) dispatch({type:ADD_TO_COMUPDS,typee:was,userid:actorId,commentId})
   }
}}

const viewedPosts = new Set()
export const add_to_views = (userid,postid) => {
  return async (dispatch,getState) =>{
    const id = String(postid || '').trim()
    if (!id || viewedPosts.has(id)) return
    viewedPosts.add(id)
    const auth = getState().authReduse || {}
    const uid = String(userid || auth.id || 'guest')
    const pid = String(auth.pid || 'guest')
    try {
      await fetch(`/api/vud/view`,{
        method:'POST',
        headers:{'content-Type':'application/json'},
        body:JSON.stringify({userid: uid, postid: id, pid})
      })
    } catch (err) {}
    dispatch({type:ADD_VIEWS,userid:uid,postid:id})
  }
}
export const add_to_follow = (leader,email,postition,job,hobby) => {
  return async (dispatch,getState) => {
    const pid = getState().authReduse.pid;
    const follower = getState().authReduse.id;
  const res = await fetch(`/api/followship/follow`,{
     method:'POST',
     headers:{'content-Type':'application/json'},
     body:JSON.stringify({leader,follower,pid})
   })
    const wasFollowing = (getState().followReduse.follow || []).some(user => String(user.userid) === String(leader) || String(user.id) === String(leader));
  dispatch({type:ADD_TO_FOLLOW,userid:leader,email:email,postition:postition,job:job,hobby:hobby,wasFollowing})
}}
export const set_follow = (leader, options = {}) => {
  return async (dispatch, getState) => {
    const pid = getState().authReduse.pid;
    const follower = getState().authReduse.id;
    if (!pid || !follower || !leader) return;
    const notify = options.notify === true;
    const unsubscribe = options.unsubscribe === true;
    await fetch('/api/followship/follow', {
      method: 'POST',
      headers: { 'content-Type': 'application/json' },
      body: JSON.stringify({ leader, follower, pid, notify, unsubscribe })
    });
    dispatch({
      type: SET_FOLLOW,
      userid: leader,
      email: options.email,
      postition: options.postition,
      job: options.job,
      hobby: options.hobby,
      notify,
      unsubscribe
    });
  }
}
export const remove_follow = (leader) =>{
  return async (dispatch,getState) =>{
    const pid = getState().authReduse.pid;
      const follower = getState().authReduse.id;
      const res = await fetch(`/api/followship/follow`,{
         method:'POST',
         headers:{'content-Type':'application/json'},
         body:JSON.stringify({leader,follower,pid})
       })
          console.log(res.json(),leader,pid);
  dispatch({type:REMOVE_FOLLOW,userid:leader})
}}
export const delete_nof = (id) =>{
  return dispatch =>{
  const res = fetch(`/api/cn/notifcations/${id}`,{
     method:'DELETE',
     headers:{'content-Type':'application/json'},
     body:JSON.stringify({id})
   })
  dispatch({type:DELETE_NOF,id:id})
}}
export const delete_mass = (id) =>{
  return dispatch =>{
  const res = fetch(`/api/cn/`,{
     method:'POST',
     headers:{'content-Type':'application/json'},
     body:JSON.stringify({id})
   })
  dispatch({type:DELETE_MASS,id:id})
}}

export const add_to_chat = (from_user,to_user,content,id,time) =>{
  return async (dispatch,getState) => {
    // const from_user = getState().authReduse.id;
  // const res = await fetch(`http://localhost:3000/api/cn/`,{
  //    method:'POST',
  //    headers:{'content-Type':'application/json'},
  //    body:JSON.stringify({from_user,to_user,content})
  //  })
  //  console.log(res.json(),from_user)
  dispatch({type:ADD_TO_CHAT,Data:{id,fromm:from_user,to:to_user,text:content,date:time || 'now',status:'sent'}})
}}

export const mark_chat_delivered = (ids) => ({
  type: MARK_CHAT_DELIVERED,
  ids
})
export const add_to_chat_send = (from_user,to_user,content) =>{
  return async () => {
    // const from_user = getState().authReduse.id;
  const res = await fetch(`/api/cn/`,{
     method:'POST',
     headers:{'content-Type':'application/json'},
     body:JSON.stringify({from_user,to_user,content})
   })
   const data = await res.json().catch(() => ({}));
   if (!res.ok) {
     const msg = data.msg;
     const first = msg && msg.errors && msg.errors[0] && msg.errors[0].msg;
     throw new Error(first || (msg && (msg.sqlMessage || msg.message)) || (typeof msg === 'string' ? msg : 'Could not send message'));
   }
   if (!data.message) throw new Error('Could not send message');
   return data.message;
}}
export const delete_post = (id) => {
  return async (dispatch, getState) => {
    const userid = getState().authReduse.id;
    if (!id || !userid) throw new Error('Could not delete post');
    const res = await fetch(`/api/posts/${encodeURIComponent(id)}/${encodeURIComponent(userid)}`, {
      method: 'DELETE'
    });
    if (!res.ok) throw new Error('Could not delete post');
    dispatch({ type: DELETE_POST, id });
  }
}

export const update_post = (post) => {
  return async (dispatch, getState) => {
    const userid = getState().authReduse.id;
    if (!post?.id || !userid) throw new Error('Could not update post');
    const res = await fetch(`/api/posts/${encodeURIComponent(post.id)}`, {
      method: 'PATCH',
      headers: { 'content-Type': 'application/json' },
      body: JSON.stringify({
        title: post.title,
        type: post.type,
        discption: post.description,
        image: post.image,
        thumbnail: post.thumbnail,
        tages: post.tages,
        userid
      })
    });
    if (!res.ok) throw new Error('Could not update post');
    dispatch({ type: UPDATE_POST, post });
  }
}

export const reorder_posts = (ids) => {
  return async (dispatch, getState) => {
    const userid = getState().authReduse.id;
    const stored = (() => {
      try { return JSON.parse(localStorage.getItem('userdata') || '{}'); } catch (_) { return {}; }
    })();
    const pid = getState().authReduse.pid || stored.pid;
    const next = (ids || []).map(id => String(id || '')).filter(Boolean);
    if (!userid || !next.length) throw new Error('Could not save order');
    dispatch({ type: REORDER_USER_POSTS, ids: next });
    const res = await fetch('/api/posts/reorder', {
      method: 'POST',
      headers: { 'content-Type': 'application/json' },
      body: JSON.stringify({ userid, pid, ids: next })
    });
    if (!res.ok) throw new Error('Could not save order');
  }
}

export const delete_history = (id) =>{
  return dispatch =>{
  const res = fetch(`http://${consts.url}/api/main/deleteHistory.php`,{
     method:'POST',
     headers:{'content-Type':'application/json'},
     body:JSON.stringify({id})
   })
  dispatch({type:DELETE_HISTORY,id:id})
}}

export const make_sub = (plan) =>{
  return async (dispatch,getState) =>{
    const pid = getState().authReduse.id;

      const res = await fetch(`/api/payment/${pid}`,{
         method:'POST',
         headers:{'content-Type':'application/json'},
         body:JSON.stringify({plan})
       })
const ress = await res.json();
// dispatch({type:MAKE_PAYMENT,url:ress})
window.open(ress.msg)


}}

export const add_to_report = (postid, userid, content, country) => {
  return async () => {
    const res = await fetch('/api/reports', {
      method: 'POST',
      headers: { 'content-Type': 'application/json' },
      body: JSON.stringify({ postid, userid, content, country: country || '' })
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.msg || 'Could not send report');
    return data;
  };
};
